import React from "react";

const RootLIPI = React.lazy(() => import("./pages/__view/home/index"));
const NewsLIPI = React.lazy(() => import("./pages/__view/news/index"));
const NewsDetailLIPI = React.lazy(() => import("./pages/__view/news/detail"));
const DocLIPI = React.lazy(() => import("./pages/__view/doc/index"));
const AboutLIPI = React.lazy(() => import("./pages/__view/about/index"));
const ContactLIPI = React.lazy(() => import("./pages/__view/contact/index"));
// Root Include

//Main Index

//Special
// const PageComingSoon = React.lazy(() => import("./pages/Pages/Special/PageComingSoon"));
// const PageComingSoon2 = React.lazy(() => import("./pages/Pages/Special/PageComingSoon2"));
const PageError = React.lazy(() => import("./pages/Pages/Special/PageError"));
// const PageThankYou = React.lazy(() => import("./pages/Pages/Special/PageThankYou"));
// const PageMaintenance = React.lazy(() => import("./pages/Pages/Special/PageMaintenance"));

const routes = [
    { path: "/page-error", component: PageError, isWithoutLayout: true },
    //routes without Layout

    //Index root

    // { path: '/', component: RootLIPI, isWithoutLayout: true, exact: true },
    { path: "/", component: RootLIPI, isTopbarDark: true },
    { path: "/berita", component: NewsLIPI, isTopbarDark: true },
    { path: "/berita/detail", component: NewsDetailLIPI, isTopbarDark: true },
    { path: "/dokumentasi", component: DocLIPI, isTopbarDark: true },
    { path: "/tentang", component: AboutLIPI, isTopbarDark: true },
    // { path: "/kontak", component: ContactLIPI, isTopbarDark: true },
    // { path: '/index-apps', component: Apps, isTopbarDark: true },
    { component: PageError, isWithoutLayout: true, exact: false },
];

export default routes;
